import { Message } from 'element-ui';
/**
 * @description 格式化发车顺序列表
 * @param {Array} list 列表数据
 */
export const formatSequenceList = list => {
    list.forEach(v => {
        v.wlLoadSequence = v.wlLoadSequence === null ? '' : v.wlLoadSequence + '';
        v.address = v.receiverProvinceName + v.receiverCityName + v.receiverDistrictName + v.receiverTownName + v.receiverDetailAddr;
    });
    return list;
};

/**
 * @description 校验列表数据是否满足提交条件
 * @param {Array} list 列表数据
 */
export const validateParams = list => {
    let flag = true;
    if (list.some(v => !v.wlLoadSequence)) {
        flag = false;
        Message.warning('装车顺序不能为空!');
        return;
    }
    return flag;
};

/**
 * @description 处理更新卫龙装车顺序接口参数
 * @param {Object} rowData 发车单列表当前操作行数据
 * @param {Array} sequenceList 装车顺序列表数据
 */
export const dealWithParams = (rowData, sequenceList) => {
    const params = {};
    params.dispatchNo = rowData.dispatchNo;
    params.transportExtends = sequenceList.map(v => ({ taskNo: v.taskNo, wlLoadSequence: v.wlLoadSequence }));
    return params;
};
